<template>
  <div>
    <b-row>
      <b-col sm="12" md="12">
        <b-card no-body>
          <b-card-header>
            <h5 class="float-left"><i class='fa fa-search mr-2'></i>Search</h5>
          </b-card-header>
          <b-card-body>
            <b-form>
              <b-row>
                <b-col sm="6" md="6" lg="4" xl="3" class="mb-2">
                  <label class="mr-sm-2" for="sUsername">Username</label>
                  <b-input placeholder="Username" v-model.trim="form.username" ></b-input>
                </b-col>
                <b-col sm="6" md="6" lg="4" xl="3" class="mb-2">
                  <label class="mr-sm-2" for="sStartTime">From</label>
                  <b-input type="date" placeholder="" v-model.trim="form.startDate" readonly></b-input>
                </b-col>
                <b-col sm="6" md="6" lg="4" xl="3" class="mb-2">
                  <label class="mr-sm-2" for="sEndTime">To</label>
                  <b-input type="date" placeholder="" v-model.trim="form.endDate" readonly></b-input>
                </b-col>
                <b-col sm="6" md="6" lg="4" xl="3" class="mb-2">
                  <label class="mr-sm-2" for="sEndTime">&nbsp;</label><br>
                  <b-button id="sBtn" variant="primary" :disabled="fetching" @click="getRealtimeMemberData"><i class="fa fa-search mr-2"></i>Search</b-button>
                </b-col>
              </b-row>
            </b-form>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12" lg="12">
        <div class="card">
          <div class="card-body">
            <b-row>
              <b-col sm="6" md="6" lg="4" xl="3">
                <b-card :no-body="true">
                  <b-card-body class="p-3 clearfix">
                    <div class="text-muted text-uppercase font-weight-bold font-xs">Total Turnover</div>
                    <template v-if="fetching">
                      <span class="text-muted font-weight-bold mb-0 mt-2">Loading...</span>
                    </template>
                    <div v-else class="h5 text-muted font-weight-bold mb-0 mt-2">{{ money(turnover) }}</div>
                  </b-card-body>
                </b-card>
              </b-col>
              <b-col sm="6" md="6" lg="4" xl="3">
                <b-card :no-body="true">
                  <b-card-body class="p-3 clearfix">
                    <div class="text-muted text-uppercase font-weight-bold font-xs">Total Netwin</div>
                    <template v-if="fetching">
                      <span class="text-muted font-weight-bold mb-0 mt-2">Loading...</span>
                    </template>
                    <div v-else class="h5 text-muted font-weight-bold mb-0 mt-2">{{ money(netwin) || '' }}</div>
                  </b-card-body>
                </b-card>
              </b-col>
              <b-col sm="6" md="6" lg="4" xl="3">
                <b-card :no-body="true">
                  <b-card-body class="p-3 clearfix">
                    <div class="text-muted text-uppercase font-weight-bold font-xs">Total Deposit</div>
                    <template v-if="fetching">
                      <span class="text-muted font-weight-bold mb-0 mt-2">Loading...</span>
                    </template>
                    <div v-else class="h5 text-muted font-weight-bold mb-0 mt-2">{{ money(deposit) || '' }}</div>
                  </b-card-body>
                </b-card>
              </b-col>
              <b-col sm="6" md="6" lg="4" xl="3">
                <b-card :no-body="true">
                  <b-card-body class="p-3 clearfix">
                    <div class="text-muted text-uppercase font-weight-bold font-xs">Total Withdraw</div>
                    <template v-if="fetching">
                      <span class="text-muted font-weight-bold mb-0 mt-2">Loading...</span>
                    </template>
                    <div v-else class="h5 text-muted font-weight-bold mb-0 mt-2">{{ money(withdraw) || '' }}</div>
                  </b-card-body>
                </b-card>
              </b-col>
              <b-col sm="6" md="6" lg="4" xl="3">
                <b-card :no-body="true">
                  <b-card-body class="p-3 clearfix">
                    <div class="text-muted text-uppercase font-weight-bold font-xs">Total Promotion</div>
                    <template v-if="fetching">
                      <span class="text-muted font-weight-bold mb-0 mt-2">Loading...</span>
                    </template>
                    <div v-else class="h5 text-muted font-weight-bold mb-0 mt-2">{{ money(promotion) || '' }}</div>
                  </b-card-body>
                </b-card>
              </b-col>
              <b-col sm="6" md="6" lg="4" xl="3">
                <b-card :no-body="true">
                  <b-card-body class="p-3 clearfix">
                    <div class="text-muted text-uppercase font-weight-bold font-xs">Total Loyalty Point</div>
                    <template v-if="fetching">
                      <span class="text-muted font-weight-bold mb-0 mt-2">Loading...</span>
                    </template>
                    <div v-else class="h5 text-muted font-weight-bold mb-0 mt-2">{{ money(loyalty) || '' }}</div>
                  </b-card-body>
                </b-card>
              </b-col>
            </b-row>
          </div>
        </div>
      </b-col>
    </b-row>
     <b-row>
      <b-col sm="12" md="12">
        <b-card no-body>
          <b-card-header>
            <h3 class="float-left">Member Realtime Detail</h3>
          </b-card-header>
          <b-card-body>
            <b-table responsive="sm" :items="items" :fields="fields" :busy="fetching" >
              <template #table-busy>
                <div class="text-center my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>Loading...</strong>
                </div>
              </template>
              <template v-slot:cell(index)="data">
                {{ data.index+1 + ((currentPage-1)*perPage) }}
              </template>
            </b-table>
            <nav>
              <b-pagination :total-rows="getRowCount()" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons />
            </nav>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>

import { PSelect } from '../../../components'
import moment from 'moment-timezone'
import money from '../../../../helper/money'
import VueNotifications from 'vue-notifications'
import { Events } from '../../../events.js'

export default {
  name: 'RealtimeTable',
  components: {
    PSelect
  },
  data () {
    return {
      fetching: false,
      currentPage: 1,
      perPage: 20,
      rowCount: 0,
      turnover: '',
      netwin: '',
      deposit: '',
      withdraw: '',
      promotion: '',
      loyalty: '',
      form: {
        startDate: moment().format('YYYY-MM-DD'),
        endDate: moment().format('YYYY-MM-DD'),
        username: ''
      },
      statusOptions: [
        { Name: 'Disabled', Value: 0 },
        { Name: 'Enabled', Value: 1 }
      ],
      items: [],
      fields: [
        { key: 'index', label: 'S.No' },
        { key: 'name', label: 'Username' },
        { key: 'turnover', label: 'Turnover' },
        { key: 'netwin', label: 'Netwin' },
        { key: 'deposit', label: 'Deposit' },
        { key: 'withdraw', label: 'Withdraw' },
        { key: 'promotion', label: 'Promotion' },
        { key: 'loyaltyPoint', label: 'Loyalty Point' }
      ]
    }
  },
  watch: {
    currentPage: function () {
      this.getRealtimeMemberData()
    }
  },
  methods: {
    money,
    getRowCount () {
      return this.rowCount
    },
    async getRealtimeMemberData () {
      try {
        this.fetching = true
        if (window.sessionStorage.getItem('client')) {
          const user = JSON.parse(window.sessionStorage.getItem('client'))
          this.agentCode = user.code
        }
        const queryParams = {
          username: this.form.username,
          startDate: this.form.startDate,
          endDate: this.form.endDate,
          page: this.currentPage,
          size: this.perPage,
          agentCode: this.agentCode
        }
        let queryStr = `?username=${queryParams.username}&startDate=${queryParams.startDate}&endDate=${queryParams.endDate}&size=${queryParams.size}&page=${queryParams.page}&agentCode=${queryParams.agentCode}`
        const { data: { data, total, totalCount } } = await this.$http.get(`${this.API_ENDPOINT}/api/v1/agent/player/realtime/data` + queryStr, { headers: { 'Content-Type': 'application/json' } })
        this.turnover = total.turnover
        this.netwin = total.netwin
        this.deposit = total.deposit
        this.withdraw = total.withdraw
        this.promotion = total.promotion
        this.loyalty = total.loyaltyPoint
        this.items = data
        this.rowCount = totalCount
      } catch (err) {
        let errMsg
        if (err.response.data && err.response.data.msg) {
          errMsg = err.response.data.msg
        } else {
          errMsg = 'Something went wrong. Please try again after some time'
        }
        Events.$emit('alert', VueNotifications.types.error, 'Error', errMsg)
      } finally {
        this.fetching = false
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/pages/Realtime/RealtimeTable.vue